<template>
    <div class="home">
        <cube-scroll ref="scroll">
            <div class="banner w100 mb20"></div>
            <div class="w100 wrapper">
                <ul class="nav w100 flex flex-wrap whiteBg mb20">
                    <li v-for="(i, k) in nav" :key='i.id' @click="go(i.path, {id: i.type})">
                        <img :src="i.icon" class="icon22 mb5" alt="">
                        <p class="f14">{{i.name}}</p>
                    </li>
                </ul>
                <div class="whiteBg mb20" v-if="adv.img">
                    <img :src="adv.img" alt="" class="adv-banner" />
                    <div class="item-info">
                        <p class="tl red f13 mb10" v-if="adv.wechat">微信：{{adv.wechat}}</p>
                        <p class="tl red f13 mb10" v-if="adv.phone">手机：{{adv.phone}}</p>
                        <p class="tl red f13" v-if="adv.qq">qq：{{adv.qq}}</p>
                    </div>
                </div>
                <div class="whiteBg recommand">
                    <p class="title base mt10 f18">宝贝推荐</p>
                    <ul class="w100">
                        <li class="w100 flex items-align border-bottom" v-for="i in list" :key='i.id'
                            @click="go('/detail',{id:i.id})">
                            <div class="goods-icon"> {{i.type | icon}} </div>
                            <div class="tl flex1">
                                <p class="mb10 f14">
                                    {{i.name}} <span v-if="i.type == 20">| {{i.influence | influence}}</span>
                                    <span v-if="i.type == 4 || i.type == 5 || i.type == 20"> | ({{i.category}})</span>  | {{i.level}} {{i.evolutionLevel | val}}
                                </p>
                                <p class="mb10 red f13" v-if="i.type == 20">武勋：{{i.compositeAttr | wx}}</p>
                                <p class="mb10 red f13" v-else>{{i.compositeAttr }}</p>
                                <p class="mb10 red f13" v-if="i.type == 20">交易方式：{{i.additionalAttr }}</p>
                                <p class="mb10 red f13" v-else>
                                    <span v-if="i.strengtheningLevel">强{{i.strengtheningLevel}} &nbsp;</span>
                                    <span>{{i.additionalAttr}}&nbsp;</span>
                                    <span>{{i.soulLevel }}&nbsp;</span>
                                    <span>{{i.qiyushi }}</span>
                                </p>
                            </div>
                            <p class="red f14">￥{{i.price}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </cube-scroll>
    </div>

</template>

<script>
  import { mapActions } from 'vuex'
  import {icons} from "../../AppConst"
  export default {
    name: 'home',
    filters:{
      val(n){
        return n == ''? '': `| ${n}`
      },
      icon (e) {
        return icons[e]
      },
      influence (e) {
        return e?'正':'邪'
      },
      wx (e) {
        return e>9999?`${(e/10000).toFixed(2)}万`:e
      }
    },
    data() {
      return {
        adv: {
          img:''
        },
        nav: [
          // {
          //   icon: require('../assets/wq.png'),
          //   name: '装备购买',
          //   path:'/viewPage'
          // },

          {
            icon: require('../assets/wq.png'),
            name: '武器',
            path:'/goods',
            type: 0
          },
          {
            icon: require('../assets/yf.png'),
            name: '衣服/下三',
            path:'/goods',
            type: 1
          },
          {
            icon: require('../assets/nj.png'),
            name: '内甲',
            path:'/goods',
            type: 2
          },
          {
            icon: require('../assets/ss.png'),
            name: '首饰',
            path:'/goods',
            type: 3
          },
          {
            icon: require('../assets/pf.jpg'),
            name: '披风',
            path:'/goods',
            type: 4
          },
          {
            icon: require('../assets/pet.gif'),
            name: '灵兽',
            path:'/goods',
            type: 5
          },
          {
            icon: require('../assets/account.png'),
            name: '账号',
            path:'/goods',
            type: 20
          },
          {
            icon: require('../assets/sale.svg'),
            name: '我要出售',
            path:'/publish'
          }
        ],
        list:[]
      }
    },
    methods: {
      ...mapActions([
        'handleRecommendGoodsList',
        'handleAdList',
        'handleShareSign'
      ]),
      init () {
        this.handleRecommendGoodsList({
          pageNo: 1,
          pageSize: 100
        }).then(res => {
          this.list = res.data
        })
        this.handleAdList({
          pageNo: 1,
          pageSize: 1
        }).then(res => {
          console.log(res)
          if (res.data && res.data[0])
            this.adv = res.data[0]
        })
      },
      //初始化微信config
      async initWX(){
        const arr = [
          '这是你需要的装备，体验飞一样的感觉，快戳！',
          '宝贝担保平台，找装备不再麻烦，快来',
        ];
        const result = arr[Math.floor(Math.random()*arr.length)]
        this.handleShareSign({url:location.href.split('#')[0]}).then(res=>{

          let {signature,timestamp,nonceStr} = res.data;
          const appid = 'wx5ebc1578479cc72b';
          if (this.$isWeixin) {
            wx.config({
              debug:false,// 是否开启调试模式
              appId:appid,// appid
              timestamp:timestamp,// 时间戳
              nonceStr:nonceStr,// 随机字符串
              signature:signature,// 签名
              jsApiList:[
                'updateAppMessageShareData',
                'updateTimelineShareData'
              ]
            })
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
              wx.updateAppMessageShareData({
                title: result, // 分享标题
                desc: ' 宝贝担保平台', // 分享描述
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://penghui.oss-cn-shanghai.aliyuncs.com/icons/logo.jpg', // 分享图标
                success: function () {
                  // 设置成功
                }
              })
              wx.updateTimelineShareData({
                title: result, // 分享标题
                desc: '宝贝担保平台', // 分享描述
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://penghui.oss-cn-shanghai.aliyuncs.com/icons/logo.jpg', // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            });
          }
        })
      }

    },
    activated(){
      this.init()
    },
    mounted() {
      this.initWX()
      this.init()
    }
  }
</script>

<style lang="less" scoped>
    .item-info{
        box-sizing: border-box;
        padding: 10px 20px;
    }
    .home{
        height: 100%;
        /*overflow: auto;*/
    }
    .banner {
        height: 180px;
        background: url('../assets/banner.png') no-repeat;
        background-size: 100% 100%;
        text-align: center;
        padding-top: 10px;
    }

    .wrapper {
        background: rgba(247, 247, 247, 1);
        padding: 5px 10px;
    }

    .nav {
        border-radius: 10px;
        padding: 10px 0;
        align-content: space-between;
        height: 130px;
        li{
            width: 25%;
        }
    }
    .recommand{
        border-radius: 10px;
        padding: 0 10px;
        .title{
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid rgba(247,247,247,1);
        }
        ul{
            li{
                padding: 15px 0 5px;

            }
        }
    }
    .adv-banner{
        width: 100%;
        height: 150px;
        margin:  10px 0 0;
        border-radius: 10px;
    }
    .goods-icon{
        width: 50px;
        min-width: 50px;
        height: 50px;
        font-size: 17px;
        color: yellow;
        margin-right: 10px;
        text-align: center;
        line-height: 50px;
        background: #0291FE;
        border-radius: 5px;
    }
</style>
